/* eslint-disable no-magic-numbers */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Box from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography';
import Link from 'carbon-react/lib/components/link';

import styles from './excel-modal-content.scss';
import excelLogo from '@futrli/shared-services/excel-upload/excel-modals/update/img/Excel Logo.png';
import Button from 'carbon-react/lib/components/button';

interface Props {
  driverTemplateLink: string;
}

export const CreateFromExcelModalContent = ({ driverTemplateLink }: Props) => {
  const intl = useIntl();
  // Carbon forwards native anchor attributes, although ButtonProps does not declare `download`.
  const downloadButtonProps = {
    download: intl.formatMessage({
      id: 'predict.drivers_template_filename',
      defaultMessage: 'Drivers Template.xls'
    })
  };

  return (
    <Box className={styles.container}>
      <img src={excelLogo} alt="Excel" width={48} height={48} style={{ marginBottom: '16px' }} />
      <Typography fontSize="14px" fontWeight="500" mb={0}>
        <FormattedMessage id="predict.create_forecast.step_x" defaultMessage="Step {step}" values={{ step: 1 }} />
      </Typography>
      <Typography fontSize="14px" mb="8px" color="var(--colors-utility-yin-055, rgba(0, 0, 0, 0.55))">
        <FormattedMessage
          id="predict.download_excel_template_below"
          defaultMessage="Download the Excel template below."
        />
      </Typography>

      <Button
        buttonType="secondary"
        mb="16px"
        iconType="download"
        iconPosition="after"
        href={driverTemplateLink}
        {...downloadButtonProps}
      >
        <FormattedMessage id="predict.drivers_template_filename" defaultMessage="Drivers Template.xls" />
      </Button>

      <Typography fontSize="14px" fontWeight="500" mb={0}>
        <FormattedMessage id="predict.create_forecast.step_x" defaultMessage="Step {step}" values={{ step: 2 }} />
      </Typography>
      <Typography fontSize="14px" color="var(--colors-utility-yin-055, rgba(0, 0, 0, 0.55))" mb="16px">
        <>
          <FormattedMessage
            id="predict.driver_data_enter"
            defaultMessage="Enter driver data, following the <link>import guidelines</link>."
            values={{
              link: chunks => (
                <Link
                  href="http://support.futrli.com/en/articles/11326527-upload-non-financial-drivers-with-an-excel-spreadsheet"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span style={{ fontWeight: 500 }}>{chunks}</span>
                </Link>
              )
            }}
          />{' '}
          <FormattedMessage
            id="predict.drivers_stored_daily_aggregate_daily_figures"
            defaultMessage="Note: drivers can be stored daily: we will aggregate daily figures into the monthly amounts displayed on the Driver’s page."
          />
        </>
      </Typography>

      <Typography fontSize="14px" fontWeight="500" mb={0}>
        <FormattedMessage id="predict.create_forecast.step_x" defaultMessage="Step {step}" values={{ step: 3 }} />
      </Typography>
      <Typography fontSize="14px" mb={0} color="var(--colors-utility-yin-055, rgba(0, 0, 0, 0.55))">
        <FormattedMessage
          id="predict.upload_data_file_max_size_25.step_3"
          defaultMessage="Upload the updated file. Max file size is 25mb."
        />
      </Typography>
    </Box>
  );
};
